export default {
  baseUrlMicrofrontend: "https://app.perf-auth.surepoint.cloud",
  ssoApiBaseUrl: "https://apiv2.perf-auth.surepoint.cloud",
  addInDomainUrl: "https://addin.perf-auth.surepoint.cloud",
  ICON_BASE_URL:
    "https://frontend-icon-store-nonprod.s3.us-east-2.amazonaws.com/fe-sso/perf/public/",
};

export const env_name = "perf";
